export default __webpack_public_path__ + "static/media/group-598.307500af.png";